import { jsx as r } from "react/jsx-runtime";
import "react";
var t = (c) => /* @__PURE__ */ r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...c,
  children: /* @__PURE__ */ r("path", {
    fill: "currentColor",
    d: "M4 8.643C4 7.736 4.784 7 5.75 7h24.5c.966 0 1.75.736 1.75 1.643s-.784 1.643-1.75 1.643H5.75C4.784 10.286 4 9.55 4 8.643Zm0 6.571c0-.907.784-1.643 1.75-1.643h24.5c.966 0 1.75.736 1.75 1.643 0 .908-.784 1.643-1.75 1.643H5.75c-.966 0-1.75-.735-1.75-1.643Zm0 6.572c0-.908.784-1.643 1.75-1.643h24.5c.966 0 1.75.735 1.75 1.643 0 .907-.784 1.643-1.75 1.643H5.75c-.966 0-1.75-.736-1.75-1.643Zm0 6.571c0-.907.784-1.643 1.75-1.643h24.5c.966 0 1.75.736 1.75 1.643 0 .908-.784 1.643-1.75 1.643H5.75C4.784 30 4 29.265 4 28.357Z"
  })
});
export {
  t as default
};
